export const Q_STORAGE_KEY = "sd_q";

let pendingCampaign = null;

export function takeCampaignFromStorage() {
  const text = sessionStorage.getItem(Q_STORAGE_KEY);
  if (text) sessionStorage.removeItem(Q_STORAGE_KEY);
  pendingCampaign = text || null;
  return pendingCampaign;
}

export function consumePendingCampaign() {
  const code = pendingCampaign;
  pendingCampaign = null;
  return code;
}

